<template>
  <div>
    <!-- 头部 -->
    <header class="common-header">
      <div class="left f fw-w">
        <el-select v-model="parameter.processingList" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="处理状态" style="width:150px;" @change="getRecordList">
          <el-option label="待处理" :value="0" />
          <el-option label="处理中" :value="1" />
          <el-option label="已完成" :value="2" />
          <el-option label="失败" :value="3" />
        </el-select>
        <el-select v-model="parameter.dealResultList" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="处理结果" style="width:150px;" @change="getRecordList">
          <el-option label="待处理" :value="0" />
          <el-option label="成功" :value="1" />
          <el-option label="失败" :value="2" />
        </el-select>
        <div>
          <el-select v-model="parameter.searchType" size="medium" style="width:110px;" class="rightBorderNone">
            <el-option label="SPU" :value="1" />
            <el-option label="商品名称" :value="2" />
          </el-select>
          <el-popover placement="bottom" width="400" trigger="click" v-if="parameter.searchType === 1">
            <el-input v-model="parameter.searchArray" size="medium" placeholder="支持批量搜索" style="width:350px" clearable @change="getRecordList" slot="reference">
              <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
            </el-input>
            <el-input v-model="parameter.searchArray" placeholder="支持批量搜索" size="medium" type="textarea" style="width:100%" clearable @change="getRecordList" :rows="6"></el-input>
          </el-popover>
          <el-input v-model="parameter.searchArray" size="medium" placeholder="输入商品名称" style="width:270px;" clearable @change="getRecordList" v-if="parameter.searchType === 2">
            <el-button slot="append" icon="el-icon-search" @click="getRecordList"></el-button>
          </el-input>
        </div>
      </div>
    </header>
    <div class="errorType f f--c" v-if="tabType === 3">
      <span style="margin-right: 8px;font-size:15px">异常类型:</span>
      <el-button v-for="item in errorTypeList" :key="item.name" type="text" @click="errorTypeClick(item)" :class="{ errorTypeActive: parameter.errorType === item.type }">{{ `${item.name}(${item.total})` }}</el-button>
    </div>

    <!-- 主体 -->
    <section class="common-section">
      <el-table :data="recordData" v-loading="loading" height="100%">
        <el-table-column label="商品信息" :min-width="400">
          <template slot-scope="{ row }">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.productPath" fit="cover"/>
              <el-image slot="reference" :src="row.productPath | imgToWebp" fit="cover" class="stock-img"/>
            </el-popover>
            <div style="display: inline-block;margin-left: 10px">
              <el-tooltip v-if="row.productName" class="item" effect="dark" :content="row.productName" placement="top-start">
                <div class="ellipsis" style="width:250px;">标题: {{ row.productName }}</div>
              </el-tooltip>
              <div v-if="row.fullCategoryName" class="ellipsis" style="width:250px;">品类: {{ row.fullCategoryName ? row.fullCategoryName : '-' }}</div>
              <div v-if="row.spuCode">SPU: {{ row.spuCode }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="skuCode" label="SKU" width="150"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" width="200"></el-table-column>
        <el-table-column prop="statusFrom" label="操作前状态" width="150"></el-table-column>
        <el-table-column prop="statusTo" label="用户操作" width="150"></el-table-column>
        <el-table-column prop="processing" label="处理状态">
          <template slot-scope="{row}">
            <div>{{ row.processing == 0  ? '待处理' : row.processing == 1 ? '处理中' : row.processing == 2 ? "已完成" : "失败" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="dealResult" label="处理结果">
          <template slot-scope="{row}">
            <div>{{ row.dealResult == 0  ? '待处理' : row.dealResult == 1 ? '成功' : row.dealResult == 2 ? "失败" : "" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="causesFailure" label="失败原因" width="200"></el-table-column>
        <el-table-column prop="creator" label="操作人"></el-table-column>
        <el-table-column prop="createDate" label="操作时间">
          <template slot-scope="{row}">
            <span>{{moment(row.createDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import API from '@/api'
export default {
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    },
    virtualWarehouse: {
      type: Array,
      default: () => []
    },
    tabType: {
      type: Number,
      default: () => 1
    }
  },
  filters: {
    imgToWebp(value) {
      return `${value}?x-oss-process=image/resize,w_98,h_98,m_fill/format,webp`
    }
  },
  data() {
    let parameter = {
      processingList: [], // 处理状态，多选
      dealResultList: [], // 处理结果，多选
      searchType: 1, // 批量搜索类型，1：spu，2：商品名称
      searchArray: undefined, // 批量搜索
      pageNumber: 1, // 当前页
      pageSize: 20, // 每日显示条数
    }
    return {
      moment: moment, // 处理日期插件
      addDate: undefined, // 筛选 - 日期选择器绑定的值
      upperOrLowerShelfParameter: {
        // 上架或者下架请求参数
        kkProductIds: [], // ids数组
        status: undefined // 0.下架 1.上架
      },
      loading: false,
      parameter: { ...parameter, tabType: this.tabType }, // 表格数据请求参数
      productData: [], // 表格数据源
      kkProductIds: [], // 表格复选框当前选中行的id数组
      total: 0, // 分页总数
      filterAlbumText: undefined, // 加入专辑对话框 - 过滤搜索框绑定的值
      albumDialogVisible: false, // 加入专辑对话框 - 是否显示加入专辑Dialog
      albumTreeData: [], // 加入专辑对话框 - Tree树形组件的数据源
      radios: undefined, // 加入品类材质树形结构单选框选中的值
      filterCategoryText: undefined, // 加入品类对话框 - 过滤搜索框绑定的值
      categoryDialogVisible: false, // 加入品类对话框 - 是否显示Dialog
      visible: false, // 列表字段配置弹框 - 是否显示Dialog
      checkAll: false, // 列表字段配置弹框 - 是否全选
      isIndeterminate: true,
      backUpColumn: [], // 后台返回的已选列表
      categoryValue: [],
      errorTypeList: [],
      selectedParam: undefined,
      recordData: [], // 状态变更记录数据源
    }
  },
  watch: {
    filterCategoryText(value) {
      this.$refs.categoryTree.filter(value)
    },
    filterAlbumText(value) {
      this.$refs.albumTree.filter(value)
    }
  },
  created() {
    if (this.tabType === 3) this.productGetErrorType()
  },
  methods: {
    // 获取状态变更记录列表
    async getRecordList(call = true) {
      try {
        this.loading = true
        if (call) this.resetPage()
        let newParameter = { ...this.parameter, tabType: this.tabType }
        newParameter.searchArray = newParameter.searchArray ? newParameter.searchArray.split('\n') : undefined
        this.$store.commit('setState', { key: 'goodsGetListParams', value: newParameter })
        let { data } = await API.getReportKakaOutReturnSkuStatusRecordList(newParameter)
        this.total = data.total
        this.recordData = data.list.map(item => ({
          ...item,
          children: [],
          hasChildren: true,
          newStatus: item.status
        }))
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },
    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.parameter.pageSize = value
      this.getRecordList(false)
    },
    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getRecordList(false)
    },
    // 搜索列表
    searchGetProductList() {
      this.productData = []
      this.getRecordList()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  // display: flex;
  width: 100%;
  height: 10%;
  align-items: center;
  .left {
    > div {
      margin-bottom: 5px;
      margin-right: 5px;
    }
    .el-input {
      width: 320px;
      .el-select {
        width: 100px;
      }
    }
    .rightBorderNone {
      margin-right: 0 !important;
      /deep/.el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        // border-right: none;
      }
    }
  }
}
.errorType {
  margin-top: 10px;
}

.common-section {
  height: calc(105vh - 294px);
  margin: 1px 0;
  .stock-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }
}

.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
/deep/.el-input-group__prepend {
  background-color: #fff !important;
}
/deep/.el-table__expand-icon {
  transform: rotate(0deg);
  > .el-icon-arrow-right::before {
    content: '\e6d9';
    border: 1px solid #ccc;
    padding: 1px;
  }
}
/deep/.el-table__expand-icon--expanded {
  .el-icon-arrow-right::before {
    content: '\e6d8';
  }
}
.errorTypeActive {
  color: #909399;
}
/deep/.el-table__row--level-0 {
  > td:nth-of-type(2) {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
</style>
